export default "__VITE_ASSET__C4$j1nnS__"